"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../../Constant");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  animation: ", " 1.75s infinite;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  animation: ", " 1.75s infinite;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  animation: ", " 1.75s infinite, ", " 1.75s infinite;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: 20vw;\n  max-width: 140px;\n  height: 33.14vw;\n  max-height: 232px;\n  margin: 0 auto 24px;\n  opacity: 0.7;\n  transform: translateZ(0); /* fixes a weird vertical line on left of animation */\n\n  div {\n    position: absolute;\n    top: 39.66%;\n    width: 32.86%;\n    height: 19.82%;\n    background-color: ", ";\n    /* this border necessary for visibility in high contrast mode */\n    border: 1px solid ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  45% {\n      top: 39.66%;\n  }\n  70%, 100% {\n      top: 0%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  30% {\n      height: 19.82%;\n  }\n  67%, 100% {\n      height: 60.34%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  40%, 100% {\n      width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var extendRight = (0, _styledComponents.keyframes)(_templateObject());
var extendDown = (0, _styledComponents.keyframes)(_templateObject2());
var moveUp = (0, _styledComponents.keyframes)(_templateObject3());

var Wrapper = _styledComponents.default.div(_templateObject4(), _Constant.Color.MOODY_BLURPLE, _Constant.Color.MOODY_BLURPLE);

var Top = _styledComponents.default.div(_templateObject5(), extendRight, moveUp);

var Middle = _styledComponents.default.div(_templateObject6(), extendRight);

var Bottom = _styledComponents.default.div(_templateObject7(), extendDown);

var FigureLogoAnimation = function FigureLogoAnimation(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Top, null), /*#__PURE__*/_react.default.createElement(Middle, null), /*#__PURE__*/_react.default.createElement(Bottom, null));
};

FigureLogoAnimation.propTypes = {
  /** class name string */
  className: _propTypes.default.string
};
FigureLogoAnimation.defaultProps = {
  className: ''
};
var _default = FigureLogoAnimation;
exports.default = _default;